import { render, staticRenderFns } from "./CardRoomName.vue?vue&type=template&id=6256a2b8&scoped=true&"
import script from "./CardRoomName.vue?vue&type=script&lang=ts&"
export * from "./CardRoomName.vue?vue&type=script&lang=ts&"
import style0 from "./CardRoomName.vue?vue&type=style&index=0&id=6256a2b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6256a2b8",
  null
  
)

export default component.exports